<template>
  <v-radio v-bind="$attrs" color="interactive" :class="`text-${radioColor}`">
    <template v-slot:label>
      <slot name="label">
        <span :class="`text-${labelColor}`">
          {{ label }}
          <span
            v-if="hint"
            class="text-mid-light-grey"
          >
            ({{ hint }})
          </span>
          <v-tooltip v-if="tooltipMsg" class="text-center" location="top" width="315">
            <template v-slot:activator="{ props: activator }">
              <v-icon v-bind="activator" class="ml-1" color="mid-grey" icon="mdi-information-outline" />
            </template>
            {{ tooltipMsg }}
          </v-tooltip>
          <new-badge v-if="showNew" class="ml-2" />
        </span>
      </slot>
    </template>
    <slot />
  </v-radio>
</template>

<script setup lang="ts">
import NewBadge from '@/components/new-badge.vue'

export interface Props {
  hint?: string
  label?: string
  labelColor?: string
  radioColor?: string
  showNew?: boolean
  tooltipMsg?: string
}
withDefaults(defineProps<Props>(), {
  hint: undefined,
  label: '',
  labelColor: 'dark-grey',
  tooltipMsg: '',
  radioColor: 'mid-light-grey',
})
</script>
